import { ethers } from 'ethers';
import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { existingDb, functions } from './firebase';

interface UserWalletData {
  salt: string;
  encryptedWallet: string;
  walletAddress: string;
}

interface WalletInfo {
  address: string;
  privateKey: string;
}

/** ユーザーのウォレットデータを取得 - users は dot99 にあるため existingDb を使用 */
export async function getUserWalletData(uid: string): Promise<UserWalletData | null> {
  const userRef = doc(existingDb, 'users', uid);
  const userDoc = await getDoc(userRef);

  if (!userDoc.exists()) {
    return null;
  }

  const data = userDoc.data();
  return {
    salt: data.salt,
    encryptedWallet: data.encryptedWallet,
    walletAddress: data.walletAddress,
  };
}

/** ウォレットを復号化して取得 */
export async function decryptWallet(salt: string, encryptedWallet: string): Promise<WalletInfo> {
  const makePassword = httpsCallable<{ salt: string }, { password: string }>(functions, 'makePassword');
  const { data } = await makePassword({ salt });

  const wallet = await ethers.Wallet.fromEncryptedJson(encryptedWallet, data.password);

  return {
    address: wallet.address,
    privateKey: wallet.privateKey,
  };
}
